import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../shared/user.service';
import { UserInfo } from '../shared/user-info.model';
import { DisplayMode } from '../../shared/display-mode';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Params } from '@angular/router';
import { LoaderService } from '../../shared/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { UserFormComponent } from '../user-form/user-form.component';
import { ComponentCanDeactivate } from '../../core/guards/pending-changes.guard';
import { NavigationService } from '../../shared/services/navigation.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-administrator-form',
  templateUrl: './administrator-form.component.html',
  styleUrls: ['./administrator-form.component.scss']
})
export class AdministratorFormComponent implements OnInit, ComponentCanDeactivate {

  user = new UserInfo();

  onCreate: (u: UserInfo) => Observable<UserInfo>;
  onUpdate: (u: UserInfo) => Observable<UserInfo>;
  onDelete: (u: UserInfo) => Observable<boolean>;
  onToggleBlocking: (u: UserInfo) => Observable<boolean>;
  onUnblockIp: (u: UserInfo) => Observable<boolean>;

  mode = DisplayMode.Creation;

  DisplayMode = DisplayMode;

  formTitle = 'New Administrator';

  @ViewChild('userForm')
  userFormComponent: UserFormComponent;

  constructor(private route: ActivatedRoute,
              private navigation: NavigationService,
              private userService: UserService,
              private loader: LoaderService,
              private toastr: ToastrService
  ) {
    this.onCreate = (u => {
      return this.userService.createAdministrator(u);
    });

    this.onUpdate = (u => {
      return this.userService.updateAdministrator(u);
    });

    this.onDelete = (u => {
      return this.userService.deleteAdministrator(u.id);
    });

    this.onToggleBlocking = (u => {
      return this.userService.toggleBlockingAdministrator(u);
    });

    this.onUnblockIp = (u => {
      return this.userService.unblockIpAdministrator(u);
    });

  }

  ngOnInit() {
    this.route.params.subscribe((params: Params): void => {
      const administratorId = params.id;

      if (!!administratorId) {
        this.loader.startLoad(false);

        this.userService.getById(administratorId)
          .pipe(finalize(() => this.loader.stopLoad()))
          .subscribe(administrator => {
            this.user = administrator;
            this.switchToUpdateMode();
          }, (error: HttpErrorResponse) => {
            console.log(error);
            this.toastr.error(error.error.message || 'An error occured while fetching the administrator', 'Error');
          });
      }
    });
  }

  getForm() {
    return this.userFormComponent.form;
  }

  switchToUpdateMode(): void {
    this.mode      = DisplayMode.Edition;
    this.formTitle = 'Administrator Edition';
  }

  goToAdminList() {
    this.navigation.administrators()
      .list()
      .go();
  }

  changePassword(password: string) {
    this.loader.startLoad();
    this.userService.updatePassword(this.user, password)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(() => {
        this.toastr.success('The password has been successfully updated', 'Success');
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error(error.error.message || 'Error while updating the password', 'Error');
      });
  }
}
